import { getOrderRedirectedPaymentTimeoutId } from '../../../selectors/order/typedOrderSelectors';
import { clearRedirectedPaymentTimeoutIdAction } from '../actions';

export const clearOrderTimeout = (getState, dispatch) => {
    const redirectedPaymentTimeoutId = getOrderRedirectedPaymentTimeoutId(
        getState(),
    );

    if (redirectedPaymentTimeoutId) {
        clearTimeout(redirectedPaymentTimeoutId);
        dispatch(clearRedirectedPaymentTimeoutIdAction());
    }
};

export default clearOrderTimeout;
